import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const youtubeRTK = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: "https://www.googleapis.com/youtube/" }),
  reducerPath: "youtubeApi",
  keepUnusedDataFor: 3600, // 5 min
  endpoints: (builder) => {
    return {
      fetchPlaylist: builder.query({
        query: () =>
          `/v3/playlistItems?part=snippet&playlistId=PLo9AF_JA2NaKd9oKtomLwpQNhgvVlmsQr&maxResults=50&key=${process.env.REACT_APP_YOUTUBE_V3_API_KEY}`,
      }),
    };
  },
});

export default youtubeRTK;

export const { useFetchPlaylistQuery } = youtubeRTK;
